import React, { useState } from "react";
import PrimaryButton from "../../utils/buttons/primaryButton";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { Alert } from "flowbite-react";
import { toast } from "react-toastify";
import { serviceRequests } from "../../../utility/api";
import axiosInstance, { notifySuccess } from "../../../utility/axiosInstance";
import { useTranslation } from "react-i18next";


function CloseCard({ data, setData, setBookModal }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  

  const {
    user: { lastName, email, phone, firstName },
    _id,
    serviceRequest,
    car: { brand, model },
    requestedAt: { date, proposedDate },
    status: serviceStatus,
    payment: { paymentStatus },
    status,
  } = data ?? {};
  const onSRStatusChange = async (
    status = "accepted",
    serviceRequestStatus
  ) => {
    setLoading(true);

    try {
      const response = await axiosInstance.put(
        `${serviceRequests.updateServiceRequest}/${_id}`,
        {
          status: "rejected",
        }
      );

      if (response.status === 200) {
        notifySuccess(t("bookServices.closeCard.serviceCancelled"));
        setBookModal(false);
        setData((prevData) => prevData.filter((item) => _id !== item?._id));
      }
    } catch (error) {
      toast("Failed to update");
    } finally {
      setLoading(false);
    }
  };
  const acceptedSR = serviceRequest?.filter(({ status }) => status);
  const rejectedSR = serviceRequest?.filter(({ status }) => !status);
  return (
    <div className="rounded-lg p-6 min-w-[460px] max-w-[460px] mx-auto bg-[#EDEDEDED] min-h-[470px]">
      <div className="space-y-4 mb-4 p-3 bg-white rounded-lg shadow-md max-w-full">
        <div className="flex justify-between items-center border-b pb-2">
          <span className="font-semibold text-gray-800 text-sm w-40">
            {t("bookServices.closeCard.name")}:
          </span>
          <span className="text-gray-600 text-sm">
            {firstName + " " + lastName}
          </span>
        </div>

        <div className="flex justify-between items-center border-b pb-3">
          <span className="font-semibold text-gray-800 text-sm">
            {t("bookServices.closeCard.email")}:
          </span>
          <span className="text-gray-600 text-sm">{email}</span>
        </div>

        {phone ? (
          <div className="flex justify-between items-center border-b pb-3">
            <span className="font-semibold text-gray-800 text-sm">
              {t("bookServices.closeCard.phone")}:
            </span>
            <span className="text-gray-600 text-sm">{phone}</span>
          </div>
        ) : null}

        <div className="flex justify-between items-center border-b pb-3">
          <span className="font-semibold text-gray-800 text-sm">
            {t("bookServices.closeCard.model")}:
          </span>
          <span className="text-gray-600 text-sm">
            {brand} {model}
          </span>
        </div>
        {acceptedSR?.length > 0 ? (
          <div className="flex justify-between items-center border-b pb-3">
            <span className="font-semibold text-gray-800 text-sm">
              {t("bookServices.closeCard.acceptedServices")}:
            </span>
            <div className="flex flex-col ">
              {acceptedSR?.map(({ service: { serviceName }, status }, key) => {
                if (key === serviceRequest.length - 1) {
                  return (
                    <span key={serviceName} className="text-gray-600 text-sm">
                      {serviceName}
                    </span>
                  );
                } else {
                  return (
                    <span key={serviceName} className="text-gray-600 text-sm">
                      {serviceName},
                    </span>
                  );
                }
              })}
            </div>
          </div>
        ) : null}
        {rejectedSR?.length > 0 ? (
          <div className="flex justify-between items-center border-b pb-3">
            <span className="font-semibold text-gray-800 text-sm">
              {t("bookServices.closeCard.rejectedServices")}:
            </span>
            <div className="flex flex-col ">
              {rejectedSR?.map(({ service: { serviceName }, status }, key) => {
                if (status == "rejected") {
                  if (key === serviceRequest.length - 1) {
                    return (
                      <span className="text-gray-600 text-sm">
                        {serviceName}
                      </span>
                    );
                  } else {
                    return (
                      <span className="text-gray-600 text-sm">
                        {serviceName},
                      </span>
                    );
                  }
                }
              })}
            </div>
          </div>
        ) : null}

        <div className="flex justify-between items-center border-b pb-3">
          <span className="font-semibold text-gray-800 text-sm">
            {t("bookServices.closeCard.serviceDate")}:
          </span>
          <span className="text-gray-600 text-sm">
            {new Date(date).toLocaleString()}
          </span>
        </div>

        {proposedDate ? (
          <div className="flex justify-between items-center border-b pb-3">
            <span className="font-semibold text-gray-800 text-sm">
              {t("bookServices.closeCard.proposedDate")}:
            </span>
            <span className="text-gray-600 text-sm flex items-center gap-2">
              {new Date(proposedDate).toLocaleString()}
              {data?.requestedAt.status === "rescheduleConfirmed" && (
                <span className="text-green-600">
                  <IoIosCheckmarkCircle />
                </span>
              )}
            </span>
          </div>
        ) : null}
        <div className="flex justify-between items-center border-b pb-3">
          <span className="font-semibold text-gray-800 text-sm">
            {t("bookServices.closeCard.paymentStatus")}
          </span>
          <span className="text-gray-600 text-sm">
            {paymentStatus === "completed"
              ? t("bookServices.closeCard.status.completed")
              : t("bookServices.closeCard.status.pending")}
          </span>
        </div>
        {paymentStatus !== "completed" && status !== "rejected" ? (
          <div className="flex flex-col gap-5 items-center">
            <PrimaryButton
              type="button"
              onClick={() => onSRStatusChange("rejected", "rejected")}
              disabled={loading}
              loading={loading}
              className={`${
                loading ? "bg-gray-500" : "bg-[#990000]"
              } hover:bg-[#990000] text-white font-semibold p-0`}
              title={t("bookServices.closeCard.cancel")}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default CloseCard;
